<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import SalesTaxReport from '../../Draftgeneration/SalesTaxReport/index.vue'
	import minhead from '../../../../common/minHead/index.vue'
	import AssetsAndLiabilities from '../../Draftgeneration/AssetsAndLiabilities/index.vue'
	import AssetsAndLiabilitiesY from '../../Draftgeneration/AssetsAndLiabilitiesY/index.vue'
	import corporateIncomeTax from '../../Draftgeneration/corporateIncomeTax/index.vue'
	import SmallScaleVAT from '../../Draftgeneration/SmallScaleVAT/index.vue'
	import valueAddedTax from '../../Draftgeneration/valueAddedTax/index.vue'
	import ConsolidatedStatement from '../../Draftgeneration/ConsolidatedStatement/index.vue'
	import TaxableService from '../../Draftgeneration/TaxableService/index.vue';
	import GeneralReturn from '../../Draftgeneration/GeneralReturn/index.vue';
	import GeneralReturnF from '../../Draftgeneration/GeneralReturnF/index.vue';
	import DisabilityPayment from '../../Draftgeneration/DisabilityPayment/index.vue';
	import AdditionalTax from '../../Draftgeneration/AdditionalTax/index.vue';
	import BalanceSheet from '../../Draftgeneration/BalanceSheet/index.vue';
	import {
		reporttrackquery,
		reporttrackdesc
	} from "../../../../../api/xggj.js"
	export default {
		name: '',
		components: {
			SalesTaxReport,
			minhead,
			SalesTaxReport,
			AssetsAndLiabilities,
			AssetsAndLiabilitiesY,
			corporateIncomeTax,
			SmallScaleVAT,
			valueAddedTax,
			ConsolidatedStatement,
			TaxableService,
			GeneralReturn,
			DisabilityPayment,
			AdditionalTax,
			BalanceSheet,
			GeneralReturnF
		},
		props: {
			showdetail: {
				type: Boolean,
				default: false,
			},
			showmintitle:{
				type: Boolean,
				default: true,
			},
			suosq: {
				type: String,
				default: "",
			},
			Saleparam:{
				type: Object,
				default: {},
			}
		},
		watch: {
			showdetail: function(indexVal, oldVal) {
				if (indexVal) {
					this.reporttrackquery()
				}
			},
		},
		data: function() {
			return {
				showbox: {
					yhs:false,
					zzs:false,
					cwbbybqyyzx:false,
					cwbbybqywzx:false,
					cwbbxqy:false,
					zzsxgm:false,
					qysdsA:false,
					
					noty:false,
					cztds: false,
					fcs:false,
					cwbbkjzd:false,
					cbj:false,
					whsy:false,
					tysl:false,
					tygh:false,
					tylj:false,
					hjbhs:false,
					xfs:false,
				},
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: [],
				smdiag: false,
				nasrmc: "",
				options: [],
				chooseval: {},
				beizsm: "",
				paramsobj:{},
				tablekey:0,
			};
		},
		created() {},
		methods: {
			inputsearch() {
				this.pagination.pageNum = 1
				this.reporttrackquery()
			},
			suosqchange() {
				this.pagination.pageNum = 1
				this.reporttrackquery()
			},
			//查询相关
			reporttrackquery() {
				let params = {}
				params.current = this.pagination.pageNum
				params.size = this.pagination.pageSize
				params.nasrmc = this.nasrmc
				params.suosq = this.suosq
				params.id = this.Saleparam.id
				reporttrackquery(params).then(res => {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records
				})
			},

			sizechange(e) {
				this.pagination.pageSize = e
				this.reporttrackquery()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.reporttrackquery()
			},
			forshuoming() {
				reporttrackdesc({
					id: this.chooseval.id,
					beizsm: this.beizsm
				}).then(res => {
					if (res.data.code == 1) {
						this.reporttrackquery()
						this.smdiag = false
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			fortzsm(val) {
				this.beizsm = ""
				this.chooseval = val
				this.beizsm=this.chooseval.beizsm
				this.smdiag = true
			},
			forckgj(val) {
				this.paramsobj=JSON.parse(JSON.stringify(this.Saleparam))
				this.paramsobj.trackId=val.id
				this.showbox[this.Saleparam.sbbm] = true
			},
			forbacksale() {
				Object.keys(this.showbox).map(key => (this.showbox[key] = false));
			},
			forback() {
				this.$emit("forback", "")
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>
